// 默认身份信息
import { stringify } from 'qs';
import request from '../fetchRequest';
import { url } from '../service-utils';

export async function getDefaultRoleUser(params) {
  return request(`${url.menu}/defaultRoleUser/get?${stringify(params)}`);
}

export async function roleUserAddOrUpdate(params) {
  return request(`${url.menu}/defaultRoleUser/addUpdate`, {
    method: 'post',
    data: params,
  });
}

// 通过选人组件新增某一角色对应的人员
export async function addBySelect(params) {
  return request(`${url.menu}/defaultRoleUser/addBySelect`, {
    method: 'post',
    data: params,
  });
}

// 删除角色中的人员
export async function roleUserDelete(params) {
  return request(`${url.menu}/defaultRoleUser/delete`, {
    method: 'post',
    data: params,
  });
}
